import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchSurfaceTypes } from './actionCreators';

interface InitialState {
  surfaceTypes: string [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  surfaceTypes: [],
  isLoading: false,
  error: '',
};

export const surfaceTypesSlice = createSlice({
  name: 'surfaceTypes',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchSurfaceTypes.fulfilled.type]: (state, action: PayloadAction<string []>) => {
      state.isLoading = false;
      state.error = '';
      state.surfaceTypes = action.payload;
    },
    [fetchSurfaceTypes.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchSurfaceTypes.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default surfaceTypesSlice.reducer;
